/** User-facing string from a caught value; pass a translated `fallback`. */
export const getErrorMessage = (err: unknown, fallback: string): string => {
  if (err instanceof Error) {
    const msg = err.message.trim();
    return msg !== '' ? err.message : fallback;
  }
  if (typeof err === 'string') {
    const trimmed = err.trim();
    return trimmed !== '' ? err : fallback;
  }
  if (err) {
    return String(err);
  }
  return fallback;
};
